import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, Observable, of, switchMap, throwError } from 'rxjs';
import { inject } from '@angular/core';

import { Router } from '@angular/router';
import { AuthService } from './autenticacion/auth..service';
import { ModalService } from './modal/modal.service';
import { environment } from '@env/environment';



export const authInterceptor: HttpInterceptorFn = (req, next) => {
  // Mover la inyección dentro del interc eptor
  const authService = inject(AuthService);
  const router = inject(Router);
  const modalService = inject(ModalService);

  if (req.url.startsWith('assets/')) {
    return next(req);
  }

  if (req.url.includes('api/Login/refreshToken')) {
    let request = req;
    request = urlRequest(request);
    return next(request); // No modificar la solicitud de refreshToken y continuar con la ejecución
  }
  let request = req;
  const token = authService.getAccessToken();

  if (token) {
    request = urlRequest(request, token);
  } else {
    request = urlRequest(request);
  }

  return next(request).pipe(
    catchError((err: HttpErrorResponse) => {
      return errorHandling(err, request, next, authService, router, modalService);
    })
  );
};

function urlRequest(request: any, token?: string) {

  let client: string | null = '';
  let apiKey: string | null = '';

  type EnvType = 'dev' | 'test' | 'demo' | 'prod';

  const apiMap: {
    urls: string[];
    env: EnvType;
    keyType: 'agenda' | 'integration';
  }[] = [
      // AGENDA
      {
        urls: [environment.apiEndPointDev],
        env: 'dev',
        keyType: 'agenda'
      },
      {
        urls: [environment.apiEndPointTest],
        env: 'test',
        keyType: 'agenda'
      },
      {
        urls: [environment.apiEndPointDemo],
        env: 'demo',
        keyType: 'agenda'
      },
      {
        urls: [environment.apiEndPointProd],
        env: 'prod',
        keyType: 'agenda'
      },

      // INTEGRATION
      {
        urls: [environment.apiIntegrationsDev],
        env: 'dev',
        keyType: 'integration'
      },
      {
        urls: [environment.apiIntegrationsTest],
        env: 'test',
        keyType: 'integration'
      },
      {
        urls: [environment.apiIntegrationsDemo],
        env: 'demo',
        keyType: 'integration'
      },
      {
        urls: [environment.apiIntegrationsProd],
        env: 'prod',
        keyType: 'integration'
      }
    ];

  const apiConfig = apiMap.find(config =>
    config.urls.some(url => request.url.startsWith(url))
  );

  if (!apiConfig) {
    const authService = inject(AuthService);
    authService.logout(false, true);
    return of(null);
  }

  client = environment.listClients[apiConfig.env];

  apiKey = apiConfig.keyType === 'agenda' ? environment.agendaKeys[apiConfig.env] : environment.integrationKeys[apiConfig.env];

  const needCredentials = apiConfig.keyType === 'agenda';

  return request.clone({
    withCredentials: needCredentials,
    setHeaders: {
      Client: client,
      'X-Internal-Key': apiKey,
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache'
    }
  });
}

function errorHandling(httpResponse: HttpErrorResponse, request: any, next: any, authService: AuthService, router: Router, modalService: ModalService): Observable<any> {
  if (httpResponse.error instanceof ErrorEvent) {
    console.error('Error de lado del cliente:', httpResponse?.error.message);
  } else if (httpResponse.status !== 0 && httpResponse.status == 429) {
    return handle429Error(httpResponse, modalService)
  } else if (window.location.href.includes('inicio') && httpResponse.status !== 0) {
    let isServerError = true;
    let errorMesagge = `Error de solicitud: ${httpResponse.message}`;

    switch (httpResponse.status) {
      case 400:
        return throwError(httpResponse);
      case 401:
        return handle401Error(request, next, authService, router);
      case 403:
        return handle403Error(httpResponse, modalService, router, authService);
      case 404:
        isServerError = httpResponse.error == null;
        errorMesagge = isServerError ? `Servicio: ${httpResponse?.url?.split('/api/')[1]} no existe en el servidor` : httpResponse?.error.Message;
        break;
      case 500:
        errorMesagge = `Error del servidor: ${httpResponse?.error.Message}`;
        break;
    }
  } else {
    console.error('Error del lado del servidor:', httpResponse);
  }
  return throwError(httpResponse);
}


function handle403Error(httpResponse: any, modalService: ModalService, router: Router, authService: AuthService): Observable<any> {
  if (httpResponse.error?.error === 'SESSION_INVALID') {
    authService.logout(false, true);
  } else if (httpResponse.error?.error === 'PERMISSION_DENIED') {
    modalService.openStatusMessage('Aceptar', httpResponse.error?.message, '4');
  }
  else {
    modalService.openStatusMessage('Aceptar', 'No esta autorizado para ver esta pagina.', '4');
  }
  return throwError(() => new Error('Forbidden - 403'));

}

function handle429Error(httpResponse: HttpErrorResponse, modalService: ModalService): Observable<never> {

  modalService.openStatusMessage(
    'Aceptar',
    httpResponse.error?.message ??
    'Demasiados intentos. Intente nuevamente más tarde.',
    '4'
  );

  return throwError(() => httpResponse);
}

function handle401Error(req: any, next: any, authService: AuthService, router: Router): Observable<any> {

  try {
    return authService.refreshTokenService().pipe(
      switchMap((res: any) => {
        authService.setAcessToken(res.data);
        const request = urlRequest(req, res.data);
        return next(request);
      }),
      catchError((err) => {
        const username = sessionStorage.getItem('username');
        const remember = sessionStorage.getItem('rememberUser');
        sessionStorage.clear();
        if (username && remember) {
          sessionStorage.setItem('username', String(username));
          sessionStorage.setItem('rememberUser', String(remember));
        }
        router.navigateByUrl("/login");
        return throwError(err);
      })
    );
  } catch (error) {
    authService.logout(false, true);
    return of(null); // Cambia a 'of(null)' para devolver un Observable
  }


}
